import React, { useEffect, useState } from "react";
import { Layout, Select } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import Logo from "./Logo";
import { NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH } from "constants/ThemeConstant";
import utils from "utils";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import roles from "../../roles";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../data/hooks/firebase/useAuth";
import { useTheme } from "../../data/hooks/theme/useTheme";

const { Header } = Layout;
const { Option } = Select;

export const HeaderNav = (props) => {
  const { isMobile } = props;
  const { navCollapsed, mobileNav, navType, headerNavColor, currentTheme, toggleCollapsedNav, toggleMobileNav } =
    useTheme();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [searchActive, setSearchActive] = useState(false);
  const { role } = useAuth();

  const onSearchClose = () => {
    setSearchActive(false);
  };

  const onToggle = () => {
    if (!isMobile) {
      toggleCollapsedNav(!navCollapsed);
    } else {
      toggleMobileNav(!mobileNav);
    }
  };

  const isNavTop = navType === NAV_TYPE_TOP ? true : false;
  const mode = () => {
    if (!headerNavColor) {
      return utils.getColorContrast(currentTheme === "dark" ? "#00000" : "#ffffff");
    }
    return utils.getColorContrast(headerNavColor);
  };
  const navMode = mode();
  const getNavWidth = () => {
    if (isNavTop || isMobile) {
      return "0px";
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
    } else {
      return `${SIDE_NAV_WIDTH}px`;
    }
  };

  useEffect(() => {
    if (!isMobile) {
      onSearchClose();
    }
  });

  const openOtherCms = (value) => {
    if (!!value) {
      const path = location.pathname;
      window.location.replace(value + path);
    }
  };

  return (
    <Header className={`app-header ${navMode}`} style={{ backgroundColor: "#FFF" }}>
      <div className={`app-header-wrapper ${isNavTop ? "layout-top-nav" : ""}`}>
        <Logo logoType={navMode} />

        <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
          <div className="nav-left">
            {isNavTop && !isMobile ? null : navCollapsed || isMobile ? (
              <MenuUnfoldOutlined
                className="nav-icon"
                onClick={() => {
                  onToggle();
                }}
              />
            ) : (
              <MenuFoldOutlined
                className="nav-icon"
                onClick={() => {
                  onToggle();
                }}
              />
            )}
          </div>
          <div className="nav-left">
            <div>
              {role === roles.superAdmin ? (
                <Select style={{ width: 250 }} defaultValue={null} onChange={openOtherCms}>
                  <Option value={null} style={{ width: "100%" }}>
                    {t("cms_navbar_title_nl")}
                  </Option>
                  <Option value={"https://cms.kuwait.chefsfarm.nl/"}>{t("cms_navbar_title_kw")}</Option>
                  <Option value={"https://cms.singapore.chefsfarm.nl/"}>{t("cms_navbar_title_sg")}</Option>
                </Select>
              ) : (
                <NavBarTitle className="ant-menu ant-menu-root ant-menu-horizontal">
                  {t("cms_navbar_title_nl")}
                </NavBarTitle>
              )}
            </div>
          </div>
          <div />
        </div>
      </div>
    </Header>
  );
};

const NavBarTitle = styled.p`
  font-size: 0.85rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default HeaderNav;
